<script>
import Static from "@/views/Static.vue";

export default {
    name: "Faq",
    extends: Static
};
</script>
